import React from "react";

const NoMatch = () => {
  return (
    <React.Fragment>
      <br />
      <h1 className="text-center">😢 404 - Page Not Found</h1>
    </React.Fragment>
  );
};

export default NoMatch;
